<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">名称</span>
        <el-input v-model="parameter.name" style="width: 200px;" placeholder="请输入内容" />
      </div>
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button type="primary" icon="el-icon-circle-plus" @click="dialogVisible = true">创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="短剧id"
        />
        <el-table-column
          prop="name"
          label="短剧名称"
        />
        <el-table-column
          prop="roi_standard"
          label="ROI标准"
        />
        <el-table-column
          prop="platform"
          label="平台名称"
        />
        <el-table-column
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
            <el-button type="warning" size="mini" @click="deleteMy(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="data.id ? '修改短剧' : '创建短剧'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="(data.name = null),(data.id = null)"
    >
      <div class="content">
        <div class="item">
          <span class="item_title">短剧名称</span>
          <el-input v-model="data.name" class="item_input" />
        </div>
        <div class="item">
          <span class="item_title">平台id</span>
          <el-select v-model="data.platform_id" filterable placeholder="请选择">
            <el-option
              v-for="item in platform"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="item_title">ROI标准</span>
          <el-input v-model="data.roi_standard" class="item_input" type="number" @input="verification" />
        </div>
      </div>
      <div style="display: flex; margin-top: 30px;justify-content: end;">
        <el-button type="primary" @click="determine">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getShortPlayList, addShortPlay, modifyShortPlay, deleteShortPlay, getPlatform } from '@/api/shortPlayReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        name: null,
        page: 1,
        pageSize: 10
      },
      data: {
        name: null,
        platform_id: null,
        roi_standard: null
      },
      platform: [],
      dialogVisible: false,
      drawer: false,
      drawerItem: {}
    }
  },
  created() {
    this.getDataList()
    this.platformList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getShortPlayList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },
    // 获取平台列表
    async platformList() {
      const data = await getPlatform({ type: 2 })
      this.platform = data.data.list
    },

    // 修改
    async modify(row) {
      this.dialogVisible = true
      this.data.name = row.name
      this.data.platform_id = row.platform_id
      this.data.roi_standard = row.roi_standard
      this.data.id = row.id
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        name: null
      }
      this.getDataList()
    },
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    async determine() {
      let text = null
      if (!this.data.name) {
        text = '请填写名称'
      }
      if (!text) {
        this.data.id ? await modifyShortPlay(this.data) : await addShortPlay(this.data)
      }
      this.$message({
        message: text || (this.data.id ? '更新成功' : '创建成功'),
        type: text ? 'warning' : 'success'
      })

      if (!text) {
        this.data.name = null
        this.data.id = null
        this.dialogVisible = false
        this.getDataList()
      }
    },

    // 删除
    deleteMy(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await deleteShortPlay(row.id)
        this.getDataList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    verification(value) {
      this.data.roi_standard = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
     margin-bottom: 10px;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}
.selectionArea{
  display: flex;
}
.item {
    display: flex;
    align-items: center;
    margin-right: 20px;
}
.title{
  display: inline-block;
  margin-right: 10px;
}
</style>
